export function snakeToSentenceCase(str: string): string {
    return str.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}

export function capsToSentenceCase (str: string) {
    // convert whole first word to lowercase
    const firstWord = str.split('is a required field')[0].toLowerCase();
    // convert first letter of first word to uppercase
    return firstWord.charAt(0).toUpperCase() + firstWord.slice(1) + str.slice(firstWord.length);
}